import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageDeliveredElectricity } from "../StartPage.types";

function useStartPageDeliveredElectricity(year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.deliveredElectricity.key(year, projectId),
    queryFn: () => fetchStartPageDeliveredElectricity(year, projectId)
  });

  return { data, error, isLoading };
}

async function fetchStartPageDeliveredElectricity(
  year: number,
  projectId?: string
) {
  const response =
    await apiWithoutCamelization.get<StartPageDeliveredElectricity>(
      urls.startPage.deliveredElectricity.url(year, projectId)
    );
  return response.data;
}

export { useStartPageDeliveredElectricity };
